import i18next from 'i18next';
import {
    FieldDefinitionFieldTypeNumeric,
    FilterCategory,
} from '@components-clean/core/filter-ui/action-bar/shared/interfaces';

export const filterColumns = (HasCMControlsPermission: boolean) => {
    return [
        {
            id: 0,
            items: [
                {
                    id: 1,
                    index: 0,
                    fieldKey: 'reviewRequired',
                    label: i18next.t('ram:riskLog.grids.risks.columns.reviewRequired'),
                    dataType: FieldDefinitionFieldTypeNumeric.Bool,
                    isDefault: false,
                },
                {
                    id: 2,
                    index: 1,
                    fieldKey: 'reviewFrequency',
                    label: i18next.t('ram:riskLog.grids.risks.columns.reviewFrequency'),
                    dataType: FieldDefinitionFieldTypeNumeric.Text,
                    isDefault: false,
                },
                {
                    id: 3,
                    index: 2,
                    fieldKey: 'internalOnly',
                    label: i18next.t('ram:riskLog.grids.risks.columns.internal'),
                    dataType: FieldDefinitionFieldTypeNumeric.Bool,
                    isDefault: false,
                },
                {
                    id: 4,
                    index: 3,
                    fieldKey: 'dateIdentified',
                    label: i18next.t('ram:riskLog.grids.risks.columns.dateIdentified'),
                    dataType: FieldDefinitionFieldTypeNumeric.Date,
                    ignoreTime: true,
                    isDefault: false,
                },
                {
                    id: 5,
                    index: 4,
                    fieldKey: 'responsibleFunction',
                    valueKey: 'name',
                    label: i18next.t('ram:riskLog.grids.risks.columns.responsibleFunction'),
                    dataType: FieldDefinitionFieldTypeNumeric.Text,
                    isDefault: false,
                },
                {
                    id: 6,
                    index: 5,
                    fieldKey: 'status',
                    label: i18next.t('ram:riskLog.grids.risks.columns.riskStatus'),
                    dataType: FieldDefinitionFieldTypeNumeric.Text,
                    isDefault: false,
                    defaultUncheckedIds: [
                        i18next.t('ra:CLOSED'),
                        i18next.t('ra:NOT_APPLICABLE'),
                        i18next.t('ra:DRAFT'),
                    ],
                },
                {
                    id: 7,
                    index: 6,
                    fieldKey: 'closedDate',
                    label: i18next.t('ram:riskLog.grids.risks.columns.closedDate'),
                    dataType: FieldDefinitionFieldTypeNumeric.Date,
                    ignoreTime: true,
                    isDefault: false,
                },
                {
                    id: 8,
                    index: 7,
                    fieldKey: 'convertedOwner',
                    valueKey: 'name',
                    label: i18next.t('ram:riskLog.grids.risks.columns.owner'),
                    dataType: FieldDefinitionFieldTypeNumeric.Text,
                    isDefault: false,
                },
                {
                    id: 9,
                    index: 8,
                    fieldKey: 'controlStrategy',
                    valueKey: 'name',
                    label: i18next.t('ram:riskLog.grids.risks.columns.controlStrategy'),
                    dataType: FieldDefinitionFieldTypeNumeric.Text,
                    isDefault: false,
                },
                {
                    id: 10,
                    index: 9,
                    fieldKey: 'category',
                    valueKey: 'name',
                    label: i18next.t('ram:riskLog.grids.risks.columns.category'),
                    dataType: FieldDefinitionFieldTypeNumeric.Text,
                    isDefault: false,
                },
                {
                    id: 11,
                    index: 10,
                    fieldKey: 'vendorList',
                    label: i18next.t('ram:riskLog.grids.risks.columns.vendors'),
                    dataType: FieldDefinitionFieldTypeNumeric.CSV,
                    isDefault: false,
                },
                {
                    id: 12,
                    index: 11,
                    fieldKey: 'countryList',
                    label: i18next.t('ram:riskLog.grids.risks.columns.countries'),
                    dataType: FieldDefinitionFieldTypeNumeric.CSV,
                    isDefault: false,
                },
                {
                    id: 13,
                    index: 12,
                    fieldKey: 'riskRating',
                    label: i18next.t('ram:riskLog.grids.risks.columns.riskRating'),
                    dataType: FieldDefinitionFieldTypeNumeric.Text,
                    isDefault: false,
                    valueOrder: [
                        i18next.t('ram:riskLog.riskRating.NONE'),
                        i18next.t('ram:riskLog.riskRating.RED'),
                        i18next.t('ram:riskLog.riskRating.AMBER'),
                        i18next.t('ram:riskLog.riskRating.GREEN'),
                    ],
                },
                {
                    id: 14,
                    index: 13,
                    fieldKey: 'reviewStatus',
                    label: i18next.t('ram:riskLog.grids.risks.columns.reviewStatus'),
                    dataType: FieldDefinitionFieldTypeNumeric.Text,
                    isDefault: false,
                },
                ...(HasCMControlsPermission
                    ? [
                          {
                              id: 15,
                              index: 14,
                              fieldKey: 'numLinkedCMControls',
                              label: i18next.t('ram:riskLog.grids.risks.columns.numLinkedCMControls'),
                              dataType: FieldDefinitionFieldTypeNumeric.Int,
                              isDefault: false,
                          },
                          {
                              id: 16,
                              index: 15,
                              fieldKey: 'oot',
                              label: i18next.t('ram:riskLog.grids.risks.columns.oot'),
                              dataType: FieldDefinitionFieldTypeNumeric.Text,
                              isDefault: false,
                          },
                      ]
                    : []),
            ],
        },
    ] as FilterCategory[];
};
